import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { UmsService } from '../ums.service';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ModalpopService } from '../modalpop.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { DatePipe } from '@angular/common';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

const EXCEL_TYPE =
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';

@Component({
  selector: 'app-student-atd',
  templateUrl: './student-atd.component.html',
  styleUrls: ['./student-atd.component.scss']
})
export class StudentAtdComponent implements OnInit {
  AttendanceForm: FormGroup;
  submitpayload: any;
  submitButton = true;
  editButton = false;
  showSubmitButton = true;
  Table = false;
  APIService: any;
  StudentTable: [];
  colrChang = false;
  CountTable: [];
  StuArray: FormArray;
  dialogRef: MatDialogRef<any>;
  dialogRef1: MatDialogRef<any>;
  sessionList: any[];
  SessionFilterList: any[];
  sessionId = 0;
  CoCode = 0;
  CgCode = 0;
  CourseList: any;
  SaveBtn = false;
  UpdateBtn = false;
  filteredListCourse: any;
  collegeList: any;
  filteredCollegeList: any;
  CountTableForApp: any[];
  inteckCount: number;
  assignTableData: any[];
  ForCsv: any;
  Student: any;
  errMsg: any;
  saveDisable = false
  updateDisable = false
  currentDate: Date;
  // jsonData: any;
  examList
  filteredListExam
  subjectList = []
  filteredsubjectList
  isBranch = false;
  attendance = 0
  BranchList
  filteredListBranch
  emid
  subcode
  savedpayload: any;
  SubAtdList: any;
  IsFile = false;
  submit = false
  AttendCounts: any;
  UserCollege
  userPermission
  ADMRecords: any[];
  Dates: any[];
  HeadList: any;
  filteredListHead: any;
  HeadCode: any;
  // Flag to prevent duplicate API calls
  isProcessing = false;
  isPartFinalSubmitted: boolean = false;

  constructor(private dialog: MatDialog,
    public umsService: UmsService,
    private modalPopupService: ModalpopService,
    private fb: FormBuilder, public router: Router, private httpClient: HttpClient,
    private spinner: NgxSpinnerService, public datepipe: DatePipe,

  ) { this.APIService = environment.serviceUrl; }

   get isCollegePrnc(): boolean {
    const perm = this.userPermission && this.userPermission[0];
    return perm && perm.CgUi === 'C' && perm.UserRole === 'PRNC';
  }


  ngOnInit(): void {
    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
    this.SaveBtn = false;
    this.submit = false
    this.UpdateBtn = false;
    this.Table = false
    this.IsFile = false;
    this.sessionId = 0;
    this.CoCode = 0;
    this.CgCode = 0;
    this.attendance = 0
    let id = ''
    this.submitButton = true;
    this.editButton = false;
    this.AttendanceForm = this.fb.group({
      college: new FormControl(''),
      course: new FormControl(''),
      SessionId: new FormControl(''),
      EmId: new FormControl(''),
      SubCode: new FormControl(''),
      EsId: new FormControl(''),
      Branch: new FormControl(''),
      StuArray: new FormArray([]),
    });
    this.fetchSession(id);
    this.getClg();
    this.currentDate = new Date();
    this.isPartFinalSubmitted = false;
  }

  getStuArrayControls() {
    return (this.AttendanceForm.get('StuArray') as FormArray).controls;
  }


  private getAttendanceDisplayValue(student: any): any {
    const count = student['AttendCount'];
    const scrutinyId = student['ScrutinyId'];
    if (
      (scrutinyId === 0 || scrutinyId === null || scrutinyId === undefined) &&
      (count === 0 || count === null || count === undefined || count === '')
    ) {
      return '';
    }
    return count;
  }

  fetchSession(id) {
    this.spinner.show();
    const payload = {};
    this.filteredListCourse = [];
    this.filteredCollegeList = [];
    payload['SnDefault'] = id;
    payload['SnNo'] = id;
    this.umsService.getSession(payload).subscribe(res => {
      this.spinner.hide();
      this.sessionList = [];
      if (res.status) {
        res.data.forEach(element => {
          if (element.SnStatus == 'O') {
            this.sessionList.push(element);
          }
        });
        this.SessionFilterList = this.sessionList.slice();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.sessionList = [];
    })
  }

  getCourse(id) {
    let payload2 = this.AttendanceForm.value
    this.Table = false
    this.UpdateBtn = false;
    this.SaveBtn = false;
    this.isBranch = false;
    this.IsFile = false;
    this.AttendanceForm.controls['course'].setValue('');
    this.AttendanceForm.controls['EmId'].setValue('');
    this.AttendanceForm.controls['Branch'].setValue('');
    this.AttendanceForm.controls['EsId'].setValue('');
    this.filteredListCourse = [];
    this.filteredsubjectList = [];
    this.filteredListExam = [];
    this.examList = [];
    this.BranchList = [];
    this.subjectList = [];
    this.CourseList = [];
    this.spinner.show();
    const payload = {};
    payload['CgCode'] = id;
    payload['CoCode'] = '';
    // getSessionColgCo
    this.umsService.getCollegeCourse(payload).subscribe((res) => {
      if (res.status) {
        const mappedCourseCodes = new Set(res.data.map((item: any) => item.CoCode));

        const payload2 = { SearchString: '' };
        this.umsService.getCourse(payload2).subscribe({
          next: (allres) => {
            this.CourseList = allres.data.filter((course: any) =>
              mappedCourseCodes.has(course.CoCode)
            );

            this.filteredListCourse = [...this.CourseList];
            this.spinner.hide();
          },
          error: () => {
            this.CourseList = [];
            this.spinner.hide();
          }
        });
      }
      else {
        this.CourseList = [];
        this.spinner.hide();
      }

    }, (ERROR: HttpErrorResponse) => {
      this.CourseList = [];
      this.spinner.hide();
    })
  }

  getClg() {
    if (this.userPermission[0].CgUi == 'C') {
      this.UserCollege = this.userPermission[0].CgId;
    }
    else {
      this.UserCollege = ''
    }
    this.Table = false;
    this.UpdateBtn = false;
    this.SaveBtn = false;
    this.subcode = '';
    this.filteredsubjectList = [];
    this.filteredListExam = [];
    this.spinner.show();
    const payload = {};
    payload['CgCode'] = this.UserCollege
    this.umsService.getCollege(payload).subscribe(res => {
      this.spinner.hide();
      this.collegeList = res.data;
      this.filteredCollegeList = this.collegeList.slice();
      if (this.userPermission[0].CgUi == 'C') {
        this.UserCollege = this.userPermission[0].CgId;
        this.AttendanceForm.controls['CgCode'].setValue(this.UserCollege);
      }
      else {
        this.UserCollege = ''
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.collegeList = [];
    })
  }

  CheckCutOff(data) {
    // Prevent multiple calls while processing
    if (this.isProcessing) return;
    this.isProcessing = true;
    
    this.IsFile = true;
    this.HeadCode = data.EsCode
    let payload = {};
    this.ADMRecords = [];
    this.Dates = [];
    payload['SnNo'] = this.AttendanceForm.value['SessionId'];
    payload['InCode'] = 'Attnd'
    payload['CoCode'] = this.AttendanceForm.value['course']
    this.umsService.CheckValidDate(payload).subscribe(res => {
      this.isProcessing = false;
      if (res.status) {
        const examRecords = res.data.filter(record => record.EmId == this.AttendanceForm.value['EmId'] && record.CoCgCoCode == this.AttendanceForm.value['course'] && record.CoCgCgCode == this.AttendanceForm.value['college']);
        const today = new Date();
        const todayDateString = today.toISOString().split('T')[0];
        if (examRecords.length > 0) {
          this.ADMRecords = res.data.filter(record => record.InCode === 'Attnd' && record.EmId == this.AttendanceForm.value['EmId'] && record.CoCgCoCode == this.AttendanceForm.value['course'] && record.CoCgCgCode == this.AttendanceForm.value['college']);
        }
        let listCanOpen = false;
        for (let item of this.ADMRecords) {
          if (((item.FromDate.split('T')[0] === todayDateString && todayDateString < item.ToDate.split('T')[0])) || ((item.FromDate.split('T')[0] < todayDateString && todayDateString < item.ToDate.split('T')[0])) || ((item.FromDate.split('T')[0] < todayDateString && todayDateString == item.ToDate.split('T')[0]))) {
            listCanOpen = true;
            break;
          }
        }
        if (!listCanOpen) {
          if (this.ADMRecords.length == 0) {
            this.showAlert('First Enter CutOff Dates For Subject Attendance');
          }
          else if (this.ADMRecords.length > 0) {
            for (let item of this.ADMRecords) {
              if (todayDateString > item.ToDate.split('T')[0]) {
                this.showAlert('Attendance Dates Are Closed For Subject Attendance');
                break;
              } else if (todayDateString < item.FromDate.split('T')[0]) {
                this.showAlert('Attendance Dates Are Still Not Open For Subject Attendance');
                break;
              }

            }
          }

        }
        if (listCanOpen == true) {
          // this.submitFinal();
          this.ShowTable();
        }
        else {

        }
      } else {
        this.showAlert('First Enter CutOff Dates For Subject Attendance');
      }
    }, error => {
      this.isProcessing = false;
    });
  }

  showAlert(message: string) {
    let data = {
      message: message,
      title: 'Alert',
      icon: 'fas fa-close'
    };
    this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
  }

  ShowTable() {
    // Prevent duplicate calls
    if (this.isProcessing) return;
    this.isProcessing = true;
    
    this.spinner.show()
    this.Table = false;
    let payload2 = this.AttendanceForm.value
    this.StuArray = this.AttendanceForm.get('StuArray') as FormArray;
    this.StuArray.clear();
    this.assignTableData = [''];
    this.StudentTable = [];
    const payload = {};
    payload['UserId'] = sessionStorage.getItem('userId');
    payload['SessionId'] = payload2.SessionId;
    payload['CoCode'] = payload2.course;
    payload['CgCode'] = payload2.college;
    payload['EsCode'] = this.subcode;
    payload['EmId'] = payload2.EmId;
    payload['HeadCode'] = this.HeadCode;
    payload['SubEsId'] = payload2.EsId
    this.umsService.getStdAtdList(payload).subscribe((res) => {
      this.isProcessing = false;
      if (res.status) {
        this.assignTableData = [''];
        this.Table = true;
        this.assignTableData = res.data;
        this.SubAtdList = res.data;
        this.attendance = res.data[0].Attendance
        if (this.attendance == null) {
          this.spinner.hide();
          let data = {}
          data['message'] = 'Subject Attendance Threshold Not Entered For This Subject.'
          data['title'] = 'Alert'
          data['icon'] = 'fas fa-close'
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
          this.saveDisable = true
          this.updateDisable = true
          this.submit = false;
          this.Table = false;
          this.StuArray.clear();
          return;
        }
        this.saveDisable = false;
        this.submit = true
        if (this.assignTableData[0]['AttendCount'] == null && this.assignTableData[0]['AttendStatus'] == null) {
          this.SaveBtn = true;
          this.UpdateBtn = false;
          // this.StuArray = this.AttendanceForm.get('StuArray') as FormArray;
          // this.StuArray['Status'].setValue('Y');
        }
        else {
          this.SaveBtn = false;
          this.UpdateBtn = true;
        }
        this.isPartFinalSubmitted = this.assignTableData.some(row => row.IsFinal === 'Y');

        this.assignTableData.forEach((element, i) => {
          const creds = this.AttendanceForm.get('StuArray') as FormArray;
          // creds.clear();
          const displayValue = this.getAttendanceDisplayValue(element);
          creds.push(
            this.fb.group({
              SrNo: new FormControl(i + 1),
              Name: new FormControl(element['StudentName']),
              Attendance: new FormControl(displayValue, [Validators.pattern('^(?:[0-9]{1,3})(?:\.[0-9]{1,2})?$'), Validators.max(100), Validators.required]),
              Status: new FormControl(element['AttendStatus']),
              StuId: new FormControl(element['StuId']),
              SctId: new FormControl(element['ScrutinyId'])
            })
          );
        });
        this.getStuAtdSet()

      } else {
        this.isProcessing = false;
        if (res.message == 'No Data Found') {
          this.getNewStu()
          // this.StudentTable = [];
          // this.Table = false;
          // this.SaveBtn = false;
          // this.UpdateBtn = false;
          // let data = {}
          // data['message'] = 'No Data Found For This Filter'
          // data['title'] = 'Alert'
          // data['icon'] = 'fas fa-close'
          // this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        }

      }

    }, error => {
      this.isProcessing = false;
      this.spinner.hide();
    });

  }

  getNewStu() {
    // Prevent duplicate calls
    if (this.isProcessing) return;
    this.isProcessing = true;
    
    this.spinner.show()
    this.Table = false;
    let payload2 = this.AttendanceForm.value
    this.StuArray = this.AttendanceForm.get('StuArray') as FormArray;
    this.StuArray.clear();
    this.assignTableData = [''];
    this.StudentTable = [];
    const payload = {};
    payload['UserId'] = sessionStorage.getItem('userId');
    payload['SnNo'] = payload2.SessionId;
    payload['CoCode'] = payload2.course;
    payload['EmId'] = payload2.EmId;
    payload['EsCode'] = this.subcode;
    payload['CgCode'] = payload2.college;
    payload['HeadCode'] = this.HeadCode;
    payload['SubEsId'] = payload2.EsId;
    this.umsService.NewSemStuAtd(payload).subscribe((res) => {
      this.isProcessing = false;
      if (res.status) {
        this.spinner.hide();
        this.assignTableData = [''];
        this.Table = true;
        this.assignTableData = res.data[0];
        if (this.assignTableData[0]['AttendCount'] == null && this.assignTableData[0]['AttendStatus'] == null) {
          this.SaveBtn = true;
          this.UpdateBtn = false;
          // this.StuArray = this.AttendanceForm.get('StuArray') as FormArray;
          // this.StuArray['Status'].setValue('Y');
        }
        else {
          this.SaveBtn = false;
          this.UpdateBtn = true;
        }
        this.assignTableData.forEach((element, i) => {
          const creds = this.AttendanceForm.get('StuArray') as FormArray;
          // this.ForCsv = element.push(this.ForCsv)

          creds.push(
            this.fb.group({
              SrNo: new FormControl(i + 1),
              Name: new FormControl(element['StudentName']),
              Attendance: new FormControl(element['AttendCount'], [Validators.pattern('^(?:[0-9]{1,3})(?:\.[0-9]{1,2})?$'), Validators.max(100), Validators.required]),
              Status: new FormControl(element['AttendStatus']),
              StuId: new FormControl(element['StuId']),
              SctId: new FormControl(element['ScrutinyId'])
            })
          );
        });
        this.getStuAtdSet()

      } else {
        this.isProcessing = false;
        this.spinner.hide();
        if (res.message == 'No Data Found') {
          this.StudentTable = [];
          this.Table = false;
          this.SaveBtn = false;
          this.UpdateBtn = false;
          let data = {}
          data['message'] = 'No Data Found For This Filter'
          data['title'] = 'Alert'
          data['icon'] = 'fas fa-close'
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        }

      }

    }, (ERROR: HttpErrorResponse) => {
      this.isProcessing = false;
      this.spinner.hide();
      this.StudentTable = [];
      this.Table = false;
      this.SaveBtn = false;
      this.UpdateBtn = false;
      let data = {}
      data['message'] = 'No Data Found For This Filter'
      data['title'] = 'Alert'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });

  }

  addNewRow() {
    const creds = this.AttendanceForm.controls.StuArray as FormArray;
    creds.push(
      this.fb.group({
        SrNo: new FormControl(''),
        Name: new FormControl(''),
        Attendance: new FormControl('', [Validators.pattern('^(?:[0-9]{1,3})(?:\.[0-9]{1,2})?$'), Validators.max(100), Validators.required]),
        Status: new FormControl('N'),
        StuId: new FormControl(''),
        SctId: new FormControl('')
      })
    );
  }

  onInputChange2(val, i) {
    this.saveDisable = false
    this.updateDisable = false
    const tempData = val.target.value;
    let taskListArrays = this.AttendanceForm.get('StuArray') as FormArray;
    if (tempData > 100) {
      if (this.SaveBtn == true) {
        this.saveDisable = true
      }
      else if (this.UpdateBtn == true) {
        this.updateDisable = true
      }
    }
    else {
      if (this.SaveBtn == true) {
        this.saveDisable = false
      }
      else if (this.UpdateBtn == true) {
        this.updateDisable = false
      }
    }
    if (tempData == '') {
      this.StuArray = this.AttendanceForm.get('StuArray') as FormArray;
      this.StuArray.at(i).get('Status').setValue('N');
    }

    let data = this.SubAtdList.find(item => item.EsCode === this.HeadCode);

    if (tempData >= data.Attendance) {
      this.StuArray = this.AttendanceForm.get('StuArray') as FormArray;
      this.StuArray.at(i).get('Status').setValue('Y');
    }
    if (tempData > data.Attendance) {
      this.StuArray = this.AttendanceForm.get('StuArray') as FormArray;
      this.StuArray.at(i).get('Status').setValue('Y');
    }
    if (tempData == data.Attendance) {
      this.StuArray = this.AttendanceForm.get('StuArray') as FormArray;
      this.StuArray.at(i).get('Status').setValue('Y');
    }
    else if (tempData < data.Attendance) {
      this.StuArray = this.AttendanceForm.get('StuArray') as FormArray;
      this.StuArray.at(i).get('Status').setValue('N');
    }

  }

  redirect(to): void {
    this.router.navigate([to]);
  }

  errorcheckR(i) {
    return i.controls['Attendance'].touched && i.controls['Attendance'].errors?.pattern
  }

  LessThan(i) {
    return i.controls['Attendance'].touched && i.controls['Attendance'].errors?.max
  }

  Save() {
    if (this.AttendanceForm.invalid) {
      this.AttendanceForm.get('college').markAsTouched();
      this.AttendanceForm.get('course').markAsTouched();
      this.AttendanceForm.get('SessionId').markAsTouched();
      this.AttendanceForm.get('EmId').markAsTouched();
      this.AttendanceForm.get('SubCode').markAsTouched();
      this.StuArray = this.AttendanceForm.get('StuArray') as FormArray;
      if (this.StuArray.invalid) {
        this.StuArray.controls.forEach(element => {
          element.get('Attendance').markAsTouched();
        })
        return
      }
      return
    }
    else {
      this.SaveAtd()
      return
    }
  }

  SaveAtd() {
    // Prevent duplicate calls
    if (this.isProcessing) return;
    this.isProcessing = true;
    
    this.spinner.show();
    this.submitpayload = this.AttendanceForm.value;
    this.AttendanceForm.controls.StuArray as FormArray;
    this.StuArray = this.AttendanceForm.get('StuArray') as FormArray;
    this.Student = this.StuArray.value
    
    let iserror = false;
    let hasError = false;
    let errorMessage = '';
    let completed = 0;
    const totalRecords = this.Student.length;
    
    if (totalRecords === 0) {
      this.isProcessing = false;
      this.spinner.hide();
      return;
    }
    
    // Process records sequentially using async/await
    this.processSaveRecordsSequentially(this.Student, 0, totalRecords);
  }

  private async processSaveRecordsSequentially(students: any[], index: number, total: number) {
    if (index >= total || this.isProcessing === false) {
      this.handleSaveCompletion();
      return;
    }

    const element = students[index];
    let payload = {};
    payload['SessionID'] = this.submitpayload['SessionId'];
    payload['CgCode'] = this.submitpayload['college'];
    payload['CoCode'] = this.submitpayload['course'];
    payload['EmId'] = this.submitpayload['EmId'];
    payload['EsId'] = this.submitpayload['EsId'];
    payload['SubCode'] = this.subcode;
    payload['Branch'] = this.submitpayload['Branch'];
    payload['StuID'] = element.StuId;
    payload['AttendCount'] = parseInt(element.Attendance) ? parseInt(element.Attendance) : '';
    payload['AttendStatus'] = element.Status ? element.Status : '';
    payload['ScrutinyID'] = element.SctId;
    payload['UserID'] = sessionStorage.getItem('userId');
    payload['EntryDateTime'] = this.currentDate;
    payload['EsParentId'] = this.submitpayload['SubCode']
    payload['HeadCode'] = this.HeadCode

    try {
      const res: any = await this.umsService.saveStdAtd(payload).toPromise();
      if (res.status == false) {
        this.errMsg = res.message;
        this.isProcessing = false;
        this.spinner.hide();
        let data = {}
        data['message'] = this.errMsg
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe((result) => {
          this.ShowTable()
        });
        return;
      }
    } catch (error) {
      this.isProcessing = false;
      this.spinner.hide();
      this.errMsg = error.error?.message || 'Error saving records';
      let data = {}
      data['message'] = this.errMsg
      data['title'] = 'Alert'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      this.dialogRef.afterClosed().subscribe((result) => {
        this.ShowTable()
      });
      return;
    }

    // Process next record
    this.processSaveRecordsSequentially(students, index + 1, total);
  }

  private handleSaveCompletion() {
    this.isProcessing = false;
    this.spinner.hide();
    let data = {}
    data['message'] = "Submitted Successfully"
    data['title'] = 'Information'
    data['icon'] = 'fas fa-check'
    this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    this.dialogRef.afterClosed().subscribe((result) => {
      this.ShowTable()
    });
  }

  update() {
    if (this.AttendanceForm.invalid) {
      this.AttendanceForm.get('college').markAsTouched();
      this.AttendanceForm.get('course').markAsTouched();
      this.AttendanceForm.get('SessionId').markAsTouched();
      this.AttendanceForm.get('EmId').markAsTouched();
      this.AttendanceForm.get('SubCode').markAsTouched();
      this.StuArray = this.AttendanceForm.get('StuArray') as FormArray;
      if (this.StuArray.invalid) {
        this.StuArray.controls.forEach(element => {
          element.get('Attendance').markAsTouched();
        })
      }
    }
    else {
      this.updateAtd()
    }
  }

  updateAtd() {
    // Prevent duplicate calls
    if (this.isProcessing) return;
    this.isProcessing = true;
    
    this.spinner.show();
    this.submitpayload = this.AttendanceForm.value;
    this.AttendanceForm.controls.StuArray as FormArray;
    this.StuArray = this.AttendanceForm.get('StuArray') as FormArray;
    this.Student = this.StuArray.value

    let hasError = false;
    let errorMessage = '';
    let completed = 0;
    const totalRecords = this.Student.length;

    if (totalRecords === 0) {
      this.isProcessing = false;
      this.spinner.hide();
      return;
    }

    // Process records sequentially using async/await
    this.processUpdateRecordsSequentially(this.Student, 0, totalRecords);
  }

  private async processUpdateRecordsSequentially(students: any[], index: number, total: number) {
    if (index >= total || this.isProcessing === false) {
      this.handleUpdateCompletion();
      return;
    }

    const element = students[index];
    let payload = {};
    payload['SessionID'] = this.submitpayload['SessionId'];
    payload['CgCode'] = this.submitpayload['college'];
    payload['CoCode'] = this.submitpayload['course'];
    payload['EmId'] = this.submitpayload['EmId'];
    payload['EsId'] = this.submitpayload['EsId'];
    payload['SubCode'] = this.subcode;
    payload['Branch'] = this.submitpayload['Branch'];
    payload['StuID'] = element.StuId;
    payload['AttendCount'] = parseInt(element.Attendance);
    payload['AttendStatus'] = element.Status;
    payload['ScrutinyID'] = element.SctId;
    payload['UserID'] = sessionStorage.getItem('userId');
    payload['EntryDateTime'] = this.currentDate;
    payload['EsParentId'] = this.submitpayload['SubCode']
    payload['HeadCode'] = this.HeadCode

    try {
      const res: any = await this.umsService.updateStdAtd(payload).toPromise();
      if (res.status == false) {
        this.errMsg = res.message;
        this.isProcessing = false;
        this.spinner.hide();
        let data = {}
        data['message'] = this.errMsg
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe((result) => {
          this.ShowTable()
        });
        return;
      }
    } catch (error) {
      this.isProcessing = false;
      this.spinner.hide();
      this.errMsg = error.error?.message || 'Error updating records';
      let data = {}
      data['message'] = this.errMsg
      data['title'] = 'Alert'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      this.dialogRef.afterClosed().subscribe((result) => {
        this.ShowTable()
      });
      return;
    }

    // Process next record
    this.processUpdateRecordsSequentially(students, index + 1, total);
  }

  private handleUpdateCompletion() {
    this.isProcessing = false;
    this.spinner.hide();
    let data = {}
    data['message'] = "Updated Successfully"
    data['title'] = 'Information'
    data['icon'] = 'fas fa-check'
    this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    this.dialogRef.afterClosed().subscribe((result) => {
      this.ShowTable()
    });
  }



  getExamList(e) {
    this.IsFile = false;
    this.spinner.show();
    this.Table = false;
    this.filteredsubjectList = [];
    this.AttendanceForm.controls['EmId'].setValue('');
    this.AttendanceForm.controls['Branch'].setValue('');
    this.AttendanceForm.controls['EsId'].setValue('');
    this.examList = [];
    this.BranchList = [];
    this.subjectList = [];
    this.isBranch = false;
    const payload = {};
    payload['EmCoCode'] = e;
    this.filteredsubjectList = [];
    this.examList = []
    this.umsService.getExam(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.examList = res.data;
        this.filteredListExam = this.examList.slice();
      }
      else {
        this.spinner.hide();
        let data = {}
        data['message'] = res.message
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);

      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Alert'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      this.ngOnInit();
      // this.umsService.openSnackbar(ERROR.error.message);

    });
  }



  getSubject(e) {
    this.IsFile = false;
    this.spinner.show();
    this.Table = false;
    this.isBranch = false;
    this.AttendanceForm.controls['Branch'].setValue('');
    this.AttendanceForm.controls['EsId'].setValue('');
    this.BranchList = [];
    this.subjectList = [];
    this.filteredsubjectList = []
    this.emid = e.EmId;
    if (e.EmStreams == "Y") {
      this.spinner.hide();
      this.isBranch = true;
      this.fetchBranch(e.EmId);
      // this.emid = e.EmId;
    } else {
      this.isBranch = false;
      const payload = {};
      payload['EsEmId'] = e.EmId;
      payload['EsStrId'] = 0;
      this.umsService.getExamSubMapFetch(payload).subscribe(res => {
        this.spinner.hide();
        res.data.children.forEach(element => {

          if (element.EsType == 'S') {
            this.subjectList.push(element)
          }
          else if (element.EsType == 'G') {
            element.children.forEach(grpSub => {
              this.subjectList.push(grpSub)
            });
          }
          this.filteredsubjectList = this.subjectList.slice();

        });
      });
    }

  }


  fetchBranch(id) {
    this.Table = false;
    const payload = {};
    this.filteredsubjectList = [];
    this.subjectList = []
    payload['EmId'] = id;
    this.umsService.getExamStream(payload).subscribe(res => {
      if (res.status) {
        this.BranchList = res.data;
        this.filteredListBranch = this.BranchList.slice();
      }
    });
  }


  getStr(e) {
    this.Table = false;
    this.IsFile = false;
    this.AttendanceForm.controls['EsId'].setValue('');
    this.subjectList = [];
    let payload = {};
    payload['EsEmId'] = this.emid;
    payload['EsStrId'] = e.StrId;
    this.umsService.getExamSubMapFetch(payload).subscribe(res => {
      res.data.children.forEach(element => {
        if (element.EsType == 'S') {
          this.subjectList.push(element)
        }
        else if (element.EsType == 'G') {
          element.children.forEach(grpSub => {
            this.subjectList.push(grpSub)
          });
        }
        this.filteredsubjectList = this.subjectList.slice();
      });
    });
  }

  subjectClick(item) {

  }

  getStuAtdSet() {
    this.spinner.show();
    this.savedpayload = this.AttendanceForm.value
    this.SubAtdList = []
    this.attendance = 0
    const payload = {};
    payload['CgCode'] = this.savedpayload.college;
    payload['CoCode'] = this.savedpayload.course;
    payload['EmId'] = this.savedpayload.EmId;
    payload['StrId'] = this.savedpayload.Branch;
    payload['SessionId'] = this.savedpayload.SessionId;
    payload['EsParentId'] = this.savedpayload.SubCode
    payload['EsCode'] = this.HeadCode
    this.umsService.getStuAtdSet(payload).subscribe(res => {

      if (res.status) {
        this.submit = true
        this.spinner.hide();
        this.SubAtdList = res.data;
        this.attendance = res.data[0].Attendance
        // this.SaveBtn =false
        let data = this.SubAtdList.find(item => item.EsCode === this.subcode);
        if (data.Attendance == null) {
          let data = {}
          data['message'] = 'Subject Attendance Threshold Not Entered For This Subject.'
          data['title'] = 'Alert'
          data['icon'] = 'fas fa-close'
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
          this.saveDisable = true
          this.updateDisable = true
          this.submit = false;
          // NEW: clear table and hide
          this.Table = false;
          this.StuArray.clear();
        }
        else {
          this.saveDisable = false;
          this.attendance = data.Attendance
          this.submit = true
          // this.UpdateBtn = false
        }

      }
      else {
        let data = {}
        data['message'] = 'Subject Attendance Not Entered For This Subject.'
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.SaveBtn = false;
        this.UpdateBtn = false;
        this.saveDisable = true;
        this.submit = false;
        this.spinner.hide();
      }



    });
  }



  File(event: any) {

    const data = {};
    data['message'] = 'Do You Want To Upload This File ?';
    data['title'] = 'Information';
    data['icon'] = 'fa fa-question';
    this.dialogRef =
      this.modalPopupService.openPopup<ConformationModelComponent>(
        ConformationModelComponent,
        data
      );
    this.dialogRef.afterClosed().subscribe((result) => {
      if (result === 'yes') {
        this.dialogRef.close();
        const files: FileList = event.target.files;
        const allowedExtensions = ['csv'];

        if (files && files.length > 0) {
          for (let i = 0; i < files.length; i++) {
            const file: File = files[i];
            const extension = file.name.split('.').pop().toLowerCase();

            if (allowedExtensions.includes(extension)) {
              // Process the selected file here (e.g., read its content or upload it)
              // let data = {};
              // data['message'] = 'File Uploaded Successfully';
              // data['title'] = 'Information';
              // data['icon'] = 'fas fa-check';
              // this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
              //   AlertBoxComponent,
              //   data
              // );

              // this.SearchEditMarks();
              // this.ControlLock2(parseInt(this.LoginId));
              this.getTextFromFile(file);

            }
          }
        }
      }
      else {
        this.dialogRef.close();
      }
    });




  }

  importDataFromCSV(csvText: string): Array<any> {
    const propertyNames = csvText
      .slice(0, csvText.indexOf('\n'))
      .split(',')
      .map(name => name.replace(/[\r\n]+/g, '').trim());  // Clean headers

    const dataRows = csvText
      .slice(csvText.indexOf('\n') + 1)
      .split('\n');

    let dataArray: any[] = [];

    dataRows.forEach((row) => {
      if (row.trim() === '') return;  // Skip empty lines

      const values = row
        .split(',')
        .map(val => val.replace(/[\r\n]+/g, '').trim());  // Clean values

      const obj: any = {};

      for (let i = 0; i < propertyNames.length; i++) {
        const key = propertyNames[i];
        const value = values[i] !== undefined ? values[i] : null;
        obj[key] = value;
      }

      dataArray.push(obj);
    });

    return dataArray;
  }

  // async getTextFromFile(file) {
  //   // const file: File = event.target.files[0];
  //   let fileContent = await file.text();
  //   const importedData = this.importDataFromCSV(fileContent);
  //   this.processCsvContents(importedData.slice(0, importedData.length - 1));
  // }
  async getTextFromFile(file: File) {
    let fileContent = await file.text();
    const importedData = this.importDataFromCSV(fileContent);

    // Filter out completely empty objects (e.g., from empty CSV rows)
    const cleanedData = importedData.filter(obj =>
      Object.values(obj).some(val => val !== null && val !== '')
    );

    this.processCsvContents(cleanedData);
  }
  processCsvContents(dataArray): void {
    this.spinner.show();
    let payload = this.AttendanceForm.value;
    let AttendanceCounttt = this.attendance
    let iserror = false;
    var bar = new Promise<void>((resolve, reject) => {
      dataArray.forEach((element, index, array) => {
        const userId: string | null = sessionStorage.getItem('userId');
        const entryDateTime: Date = this.currentDate;
        let student = this.StuArray.value;
        let attEsId = this.SubAtdList[0]
        element.CoCode = this.AttendanceForm.value.course;
        element.SubCode = this.subcode
        element.HeadCode = this.HeadCode
        element.EsId = this.AttendanceForm.value['EsId'];
        element.EmId = attEsId.EmId;
        element.SessionID = this.AttendanceForm.value.SessionId;
        element.UserID = userId;
        element.EntryDateTime = entryDateTime;
        element.EsParentId = payload['SubCode']
        element.CgCode = this.AttendanceForm.value.college;
        element['AttendCount'] = parseInt(element['AttendCount']);
        this.AttendCounts = this.assignTableData[0]['AttendCount'];
        this.assignTableData[0]['AttendCount']
        if (AttendanceCounttt == parseInt(element['AttendCount']) || parseInt(element['AttendCount']) > AttendanceCounttt) {
          element['AttendStatus'] = 'Y'
        }
        else {
          element['AttendStatus'] = 'N'
        }
        if (this.AttendCounts == '' || this.assignTableData[0]['AttendCount'] == null) {
          this.spinner.show();
          this.umsService.saveStdAtd(element).subscribe((res) => {
            if (res.status == false) {
              this.spinner.hide();
              iserror = true;
              this.errMsg = res.message
            }
            if (index === array.length - 1) resolve();
            else {
              this.spinner.hide();
              iserror = false
              this.errMsg = res.message

            }
          }, (ERROR: HttpErrorResponse) => {
            this.spinner.hide();

          });
        } else {
          this.spinner.show();
          this.umsService.updateStdAtd(element).subscribe((res) => {
            if (res.status == false) {
              this.spinner.hide();
              iserror = true;
              this.errMsg = res.message
            }
            if (index === array.length - 1) resolve();
            else {
              this.spinner.hide();
              iserror = false
              this.errMsg = res.message
              // this.ngOnInit()
            }
          }, (ERROR: HttpErrorResponse) => {
            this.spinner.hide();

          });
        }

      });
    })
    bar.then(() => {
      if (iserror == false) {
        let data = {}
        data['message'] = "Uploaded Successfully"
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe((result) => {
          this.ShowTable2()
        });

      } else {
        let data = {}
        data['message'] = this.errMsg
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe((result) => {
          // this.ShowTable()
        });
      }
    });
  }

  // async processCsvContents(dataArray): Promise<void> {
  //   this.spinner.show();
  //   let payload = this.AttendanceForm.value;
  //   let AttendanceCounttt = this.attendance;
  //   let iserror = false;
  //   const userId: string | null = sessionStorage.getItem('userId');
  //   const entryDateTime: Date = this.currentDate;
  //   const attEsId = this.SubAtdList[0];

  //   for (let element of dataArray) {
  //     let student = this.StuArray.value;

  //     // Add required fields
  //     element.CoCode = payload.course;
  //     element.SubCode = this.subcode;
  //     element.HeadCode = this.HeadCode;
  //     element.EsId = payload['EsId'];
  //     element.EmId = attEsId.EmId;
  //     element.SessionID = payload.SessionId;
  //     element.UserID = userId;
  //     element.EntryDateTime = entryDateTime;
  //     element.EsParentId = payload['SubCode'];
  //     element.CgCode = payload.college;
  //     element['AttendCount'] = parseInt(element['AttendCount']);

  //     this.AttendCounts = this.assignTableData[0]['AttendCount'];

  //     // Determine Attendance Status
  //     element['AttendStatus'] = (AttendanceCounttt === element['AttendCount'] || element['AttendCount'] > AttendanceCounttt) ? 'Y' : 'N';

  //     try {
  //       if (this.AttendCounts == '' || this.assignTableData[0]['AttendCount'] == null) {
  //         const res: any = await this.umsService.saveStdAtd(element).toPromise();
  //         if (res.status === false) {
  //           iserror = true;
  //           this.errMsg = res.message;
  //         }
  //       } else {
  //         const res: any = await this.umsService.updateStdAtd(element).toPromise();
  //         if (res.status === false) {
  //           iserror = true;
  //           this.errMsg = res.message;
  //         }
  //       }
  //     } catch (error) {
  //       iserror = true;
  //       this.errMsg = 'API error occurred';
  //       console.error(error);
  //     }
  //   }

  //   this.spinner.hide();

  //   // Final popup
  //   let data = {};
  //   if (!iserror) {
  //     data['message'] = "Uploaded Successfully";
  //     data['title'] = 'Information';
  //     data['icon'] = 'fas fa-check';
  //   } else {
  //     data['message'] = this.errMsg;
  //     data['title'] = 'Alert';
  //     data['icon'] = 'fas fa-close';
  //   }

  //   this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
  //   this.dialogRef.afterClosed().subscribe(() => {
  //     if (!iserror) this.ShowTable2();
  //   });
  // }
  download2(event: Event) {
    console.log('this.assignTableDatathis.assignTableData', this.assignTableData);

    event.preventDefault();
    const extractedData = this.assignTableData.map(element => ({
      P_NO: `="${element.StuRgNo}"`,
      StuID: element.StuId,
      Name: element.StudentName,
      AttendCount: element.AttendCount,
      Branch: element.Branch,
      PartCode: element.SubHeadCode
    }));

    // Convert array data to CSV format
    const csvContent = this.convertArrayToCSV(extractedData);
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'data.csv'; // You can change the file name if needed
    document.body.appendChild(link);

    // Trigger the download
    link.click();
  }

  // convertArrayToCSV(array) {
  //   const header = Object.keys(array[0]).join(',');
  //   const rows = array.map(obj => Object.values(obj).map(value => `"${value}"`).join(','));
  //   return [header, ...rows].join('\n');
  // }

  convertArrayToCSV(array) {
    const header = Object.keys(array[0]).join(',');

    const rows = array.map(obj =>
      Object.values(obj).map(value => {
        // Handle values that already contain quotes or commas
        const stringValue = String(value);
        if (stringValue.startsWith('="')) {
          return stringValue; // Already formatted to preserve Excel text
        }
        if (stringValue.includes(',') || stringValue.includes('"')) {
          return `"${stringValue.replace(/"/g, '""')}"`;
        }
        return stringValue;
      }).join(',')
    );

    return [header, ...rows].join('\n');
  }

  ShowTable2() {
    // Prevent duplicate calls
    if (this.isProcessing) return;
    this.isProcessing = true;
    
    this.spinner.show()
    this.Table = false;
    let payload2 = this.AttendanceForm.value
    this.StuArray = this.AttendanceForm.get('StuArray') as FormArray;
    this.StuArray.clear();
    this.assignTableData = [];
    this.StudentTable = [];
    const payload = {};
    payload['UserId'] = sessionStorage.getItem('userId');
    payload['SessionId'] = payload2.SessionId;
    payload['CoCode'] = payload2.course;
    payload['CgCode'] = payload2.college;
    payload['EsCode'] = this.subcode;
    payload['EmId'] = payload2.EmId;
    payload['HeadCode'] = this.HeadCode;
    payload['SubEsId'] = payload2.EsId
    this.umsService.getStdAtdList(payload).subscribe((res) => {
      this.isProcessing = false;
      console.log("hello")
      if (res.status) {
        this.assignTableData = [];
        this.Table = true;
        this.assignTableData = res.data;
        this.attendance = res.data[0].Attendance

        // NEW: if threshold is missing, stop and clear everything
        if (this.attendance == null) {
          this.spinner.hide();
          let data = {}
          data['message'] = 'Subject Attendance Threshold Not Entered For This Subject.'
          data['title'] = 'Alert'
          data['icon'] = 'fas fa-close'
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
          this.saveDisable = true
          this.updateDisable = true
          this.submit = false;
          this.Table = false;
          this.StuArray.clear();
          return;
        }

        if (this.assignTableData[0]['AttendCount'] == null && this.assignTableData[0]['AttendStatus'] == null) {
          this.SaveBtn = true;
          this.UpdateBtn = false;
          // this.StuArray = this.AttendanceForm.get('StuArray') as FormArray;
          // this.StuArray['Status'].setValue('Y');
        }
        else {
          this.SaveBtn = false;
          this.UpdateBtn = true;
        }

        // NEW: check if any row has final submission
        this.isPartFinalSubmitted = this.assignTableData.some(row => row.IsFinal === 'Y');

        this.assignTableData.forEach((element, i) => {
          const creds = this.AttendanceForm.get('StuArray') as FormArray;
          // creds.clear();
          const displayValue = this.getAttendanceDisplayValue(element);
          creds.push(
            this.fb.group({
              SrNo: new FormControl(i + 1),
              Name: new FormControl(element['StudentName']),
              Attendance: new FormControl(displayValue, [Validators.pattern('^(?:[0-9]{1,3})(?:\.[0-9]{1,2})?$'), Validators.max(100), Validators.required]),
              Status: new FormControl(element['AttendStatus']),
              StuId: new FormControl(element['StuId']),
              SctId: new FormControl(element['ScrutinyId'])
            })
          );
        });
        this.getStuAtdSet()

      } else {
        this.isProcessing = false;
        if (res.message == 'No Data Found') {
          this.getNewStu()
          // this.StudentTable = [];
          // this.Table = false;
          // this.SaveBtn = false;
          // this.UpdateBtn = false;
          // let data = {}
          // data['message'] = 'No Data Found For This Filter'
          // data['title'] = 'Alert'
          // data['icon'] = 'fas fa-close'
          // this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        }

      }

    }, error => {
      this.isProcessing = false;
      this.spinner.hide();
    });

  }

  getHeadCode(id) {
    this.subcode = id.EsCode;
    this.filteredListHead = []
    const payload = {};
    payload['EsId'] = id.EsId
    this.umsService.getThHead(payload).subscribe(res => {
      if (res.status) {
        this.HeadList = res.data
        this.filteredListHead = this.HeadList.slice();
      }
      else {
        this.HeadList = []
        this.filteredListHead = [];
      }
    })
  }

  downloadTeacherData() {
    this.spinner.show();

    let payload2 = this.AttendanceForm.value
    const payload = {};
    payload['UserId'] = sessionStorage.getItem('userId');
    payload['SnNo'] = payload2.SessionId;
    payload['CoCode'] = payload2.course;
    payload['CgCode'] = payload2.college;
    payload['EsCode'] = this.subcode;
    payload['EmId'] = payload2.EmId;
    payload['HeadCode'] = this.HeadCode;
     payload['SubEsId'] = payload2.EsId

    this.umsService.NewSemStuAtd(payload).subscribe((res: any) => {
      this.spinner.hide();

      if (!res.status || !res.data || res.data.length === 0) {
        alert('No student attendance available to download!');
        return;
      }

      const allData = res.data.flat();

      const selectedData = allData.map((t, index) => ({
        'PRN No': t.StuRgNo || '',
        'Studenet Name': t.StudentName || t.StuFirstNameEng || '',
        'Subject Name': t.MainSub || '',
        'Head Code': t.SubHeadCode || '',
        'College Code': t.CgCode || '',
        'Attend Count': t.AttendCount || '',
      }));

      const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(selectedData);
      const workbook: XLSX.WorkBook = {
        Sheets: { 'Student Attendance': worksheet },
        SheetNames: ['Student Attendance']
      };
      const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
      const data: Blob = new Blob([excelBuffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
      });
      saveAs(data, 'Student_Attendance_' + new Date().toISOString().slice(0, 10) + '.xlsx');
    },
      (error) => {
        this.spinner.hide();
        console.error('Error downloading student attendance:', error);
        alert('Something went wrong while downloading data!');
      });
  }

  // NEW: validate all attendance entries
  validateAllAttendance(): boolean {
    const stuArray = this.AttendanceForm.get('StuArray') as FormArray;
    for (let i = 0; i < stuArray.length; i++) {
      const attendanceControl = stuArray.at(i).get('Attendance');
      if (!attendanceControl || attendanceControl.value === '' || attendanceControl.value === null || attendanceControl.value === undefined) {
        return false;
      }
    }
    return true;
  }

  // NEW: final submission flow
  SaveFinal(): void {
    if (this.isPartFinalSubmitted) {
      this.showAlert('Final submission has already been completed for this part.');
      return;
    }

    if (!this.validateAllAttendance()) {
      this.showAlert('Please enter attendance for all students before final submission.');
      return;
    }

    const data: any = {
      message: 'Are you sure you want to make your final submission for this part? You will not be able to make any changes afterward.',
      title: 'Alert',
      icon: 'fa fa-question',
    };
    this.dialogRef = this.modalPopupService.openPopup<ConformationModelComponent>(ConformationModelComponent, data);
    this.dialogRef.afterClosed().subscribe((result) => {
      if (result === 'yes') {
        this.spinner.show();
        this.saveOrUpdateBeforeFinal();
      }
    });
  }

  private saveOrUpdateBeforeFinal(): void {
    this.submitpayload = this.AttendanceForm.value;
    this.StuArray = this.AttendanceForm.get('StuArray') as FormArray;
    this.Student = this.StuArray.value;

    // Filter students with non-empty attendance
    const studentsToSend = this.Student.filter(student => {
      const attVal = student.Attendance;
      return attVal !== '' && attVal !== null && attVal !== undefined;
    });

    if (studentsToSend.length === 0) {
      this.spinner.hide();
      this.showAlert('No attendance data to save/update.');
      return;
    }

    let iserror = false;
    let completed = 0;
    const total = studentsToSend.length;
    const useUpdate = this.UpdateBtn; // true if we should use update, false for save

    studentsToSend.forEach((element, index, array) => {
      let payload = {};
      payload['SessionID'] = this.submitpayload['SessionId'];
      payload['CgCode'] = this.submitpayload['college'];
      payload['CoCode'] = this.submitpayload['course'];
      payload['EmId'] = this.submitpayload['EmId'];
      payload['EsId'] = this.submitpayload['EsId'];
      payload['SubCode'] = this.subcode;
      payload['Branch'] = this.submitpayload['Branch'];
      payload['StuID'] = element.StuId;
      payload['AttendCount'] = parseInt(element.Attendance);
      payload['AttendStatus'] = element.Status ? element.Status : '';
      payload['ScrutinyID'] = element.SctId;
      payload['UserID'] = sessionStorage.getItem('userId');
      payload['EntryDateTime'] = this.currentDate;
      payload['EsParentId'] = this.submitpayload['SubCode'];
      payload['HeadCode'] = this.HeadCode;

      const serviceCall = useUpdate
        ? this.umsService.updateStdAtd(payload)
        : this.umsService.saveStdAtd(payload);

      serviceCall.subscribe({
        next: (res) => {
          completed++;
          if (res.status == false) {
            iserror = true;
            this.errMsg = res.message;
          }
          if (completed === total) {
            if (!iserror) {
              this.submitFinalAttendance();
            } else {
              this.spinner.hide();
              this.showAlert(this.errMsg || 'Save/Update failed.');
            }
          }
        },
        error: (ERROR: HttpErrorResponse) => {
          completed++;
          iserror = true;
          this.errMsg = ERROR.error.message;
          if (completed === total) {
            this.spinner.hide();
            this.showAlert(this.errMsg || 'An error occurred.');
          }
        }
      });
    });
  }

  private submitFinalAttendance(): void {
    const formValue = this.AttendanceForm.value;
    const payload = {
      CoCode: formValue.course,
      CgCode: formValue.college,
      SessionID: formValue.SessionId,
      EmId: formValue.EmId,
      EsId: formValue.EsId,
      SubCode: this.subcode,
      HeadCode: this.HeadCode,
      EsParentId: formValue.SubCode,
      UserID: sessionStorage.getItem('userId')
    };

    this.umsService.submitFinalAttendance(payload).subscribe({
      next: (res) => {
        this.spinner.hide();
        if (res.status) {
          this.isPartFinalSubmitted = true;
          this.saveDisable = true;
          this.updateDisable = true;
          this.SaveBtn = false;
          this.UpdateBtn = false;
          let data = {
            message: res.message || 'Final submission completed successfully for this part.',
            title: 'Information',
            icon: 'fas fa-check'
          };
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
          this.dialogRef.afterClosed().subscribe(() => {
            this.ShowTable();
          });
        } else {
          this.showAlert(res.message || 'Final submission failed.');
        }
      },
      error: (err) => {
        this.spinner.hide();
        this.showAlert(err.error?.message || 'An error occurred during final submission.');
      }
    });
  }
}